import { forwardRef, type ReactNode } from 'react';
import { Icon, type IconName } from '@/components/foundations';

export type ConnectionCardProps = {
  icon?: IconName;
  /** Cor do círculo do ícone (`.circ`): padrão dourado. */
  iconTone?: 'gold' | 'blue' | 'sky';
  title?: ReactNode;
  /** Linha abaixo do título. Sem ela o título fica direto no cabeçalho (ex.: Webhooks). */
  subtitle?: ReactNode;
  /** Selo à direita do cabeçalho (ex.: `<Badge icon="checkc">Ativo</Badge>`). */
  status?: ReactNode;
  /** Ação no rodapé, alinhada à direita (`.right`). */
  action?: ReactNode;
  /** Cabeçalho próprio no lugar do `.ic-head` (ex.: WooCommerce). */
  head?: ReactNode;
  id?: string;
  className?: string;
  children?: ReactNode;
};

/**
 * Cartão de conexão/integração (`.card.ic-card`), base comum das conexões de Finanças
 * e das integrações do lojista (chaves, webhooks, endpoint, WooCommerce).
 */
export const ConnectionCard = forwardRef<HTMLElement, ConnectionCardProps>(function ConnectionCard(
  { icon = 'link', iconTone = 'gold', title, subtitle, status, action, head, id, className, children },
  ref,
) {
  return (
    <article className={className ? `card ic-card ${className}` : 'card ic-card'} id={id} ref={ref}>
      {head ?? (
        <div className="ic-head">
          <div className={iconTone === 'gold' ? 'circ' : `circ ${iconTone}`}><Icon name={icon} /></div>
          {subtitle !== undefined ? <div><h2>{title}</h2><p>{subtitle}</p></div> : <h2>{title}</h2>}
          {status}
        </div>
      )}
      {children}
      {action !== undefined && <div className="right">{action}</div>}
    </article>
  );
});
